import { gql } from '@apollo/client'

export default gql`
  mutation sortAssignments($ids: [ID]!) {
    sortAssignments(ids: $ids) {
      id
      sortPosition
    }
  }
`
